import React, { useEffect, useState } from "react";
import type { PollProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList, Image } from "react-native";
import { Checkbox, Icons, SearchBox } from "../../Components";
import moment from "moment-mini";
import { PartnerPortalApi } from "../api";

type FlashMarketSelectorProps = {
    company_id:string,
    active_markets:string[],
    flash_campaigns:string[],
    onSelectMarket:(poll:PollProps) => void,
    onDeselectMarket:(poll:PollProps) => void
}
const FlashMarketSelector = ({ company_id, active_markets, onSelectMarket, onDeselectMarket, flash_campaigns }:FlashMarketSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);
    const [ markets, setMarkets ] = useState<PollProps[]>([])
    const [ search, setSearch ] = useState('');

    const filtered_competitions = markets.filter(pr => pr.poll_question.toLowerCase().includes(search.toLowerCase())).slice(0,10)

    useEffect(() => {
        getCompetitions()
    },[company_id, flash_campaigns.length]);
    
    const getCompetitions = async() => {
        PartnerPortalApi.setEnvironment();
        if(flash_campaigns.length == 0){ return }
        //Snag all the company flash markets
        //get all polls from the campaigns
        let s_polls:PollProps[] = []
        const getPolls = flash_campaigns.map(async c => {
            let resp = await PartnerPortalApi.EngagementApi.getFlashMarketsByCampaignId(c);
            if(!resp){ return }
            resp.polls.map(p => s_polls.push(p))
        });
        await Promise.all(getPolls);
        setMarkets(s_polls);
    }

    const renderMarkets = (data:{ item:PollProps, index:number }) => {
        const selected = active_markets.includes(data.item.poll_id.toString());

        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => {
                    if(selected){ return onDeselectMarket(data.item) }
                    return onSelectMarket(data.item);
                }}
            >
                <Image
                    source={{ uri: data.item.poll_image?.url }}
                    style={{ height: 35, width:35 }}
                    resizeMode="cover"
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.poll_question}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.status.toUpperCase()}</Text>
                </View>
                <Checkbox
                    checked={selected}
                    disabled
                    onSelect={() => console.log('')}
                />
            </Button>
        )
    }

    return (
        <View float style={{ padding:15 }}>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => {
                if(flash_campaigns.length == 0){ return alert('Please select a campaign') }
                setVisible(!visible)
            }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_markets.length} Markets</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <SearchBox
                onChange={(text) => setSearch(text)}
                hide_search_button
            />
            <FlatList
                data={filtered_competitions.sort((a,b) => a.status.localeCompare(b.status) || moment(b.end_datetime).unix() - moment(a.end_datetime).unix() || moment(b.create_datetime).unix() - moment(a.create_datetime).unix() )}
                key={'comp_selector'}
                keyExtractor={item => item.poll_id.toString()}
                renderItem={renderMarkets}
            />
            </View>
            :<></>}
        </View>
    )
}

export default FlashMarketSelector